import React from "react";

export default function FloatingButtons() {
  // IMPORTANT: Update these with your actual contact details
  // Phone number in international format (e.g., +91 for India)
  const PHONE_NUMBER = "+919619101155";
  
  // WhatsApp number: same as phone but without + or spaces (e.g., 919619101155)
  const WHATSAPP_NUMBER = "919619101155";

  const handleCall = () => {
    if (PHONE_NUMBER && PHONE_NUMBER !== "+919619101155") {
      // Remove any non-numeric characters except +
      const cleanNumber = PHONE_NUMBER.replace(/[^\d+]/g, '');
      window.location.href = `tel:${cleanNumber}`;
    } else {
      alert("Please update the phone number in FloatingButtons.js");
    }
  };

  const handleWhatsApp = () => {
    if (WHATSAPP_NUMBER && WHATSAPP_NUMBER !== "919619101155") {
      const message = "Hi! I would like to know more about your services.";
      const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, "_blank");
    } else {
      alert("Please update the WhatsApp number in FloatingButtons.js");
    }
  };

  return (
    <div className="floating-buttons">
      {/* Call Button - Left Side */}
      <button 
        className="floating-btn call-btn" 
        onClick={handleCall}
        title="Call Us"
        aria-label="Call us"
        type="button"
      >
        <span className="btn-icon">☎️</span>
        <span className="btn-label">Call</span>
      </button>

      {/* WhatsApp Button - Right Side */}
      <button 
        className="floating-btn whatsapp-btn" 
        onClick={handleWhatsApp}
        title="Chat on WhatsApp"
        aria-label="Chat on WhatsApp"
        type="button"
      >
        <span className="btn-icon">💬</span>
        <span className="btn-label">Chat</span>
      </button>
    </div>
  );
}
